import { useState, useEffect } from 'react';

type Platform = 'web' | 'electron';

const usePlatform = (): Platform => {
  const [platform, setPlatform] = useState<Platform>('web');

  useEffect(() => {
    if (window && window.process && window.process.type) {
      setPlatform('electron');
    }
  }, []);

  return platform;
};

export default usePlatform;